<template>
  <div class="vld-parent">
    <!-- <loading
      :active.sync="isLoading"
      :can-cancel="true"
      :on-cancel="onCancel"
      :is-full-page="fullPage"
    ></loading> -->
    <loading :active.sync="isLoading" :can-cancel="true" :is-full-page="fullPage"></loading>
    <menu-superior
      :link="'/' + this.$store.state.empresa_url + '/menu'"
      titulo="MEU PEDIDO"
      :style="'background-color: ' + this.$store.state.empresa.cor_primaria"
    ></menu-superior>
    <div class="bloco" >
      <titulo-destacado
        :fundo="'white'"
        titulo="Resumo do seu pedido"
        :style="
          'border-style: solid;border-width: 1px;border-color: ' +
          this.$store.state.empresa.cor_primaria +
          ';color:' +
          this.$store.state.empresa.cor_primaria
        "
      >
        <span
          v-if="!this.$store.state.pedido.itens.length > 0"
          class="valid-badge new badge cor-primaria-bg"
          data-badge-caption=""
        >Obrigatório</span
        >
        <span v-else class="valid-check material-icons md-38 cor-primaria-text"
        >check_circle_outline</span
        >
      </titulo-destacado>
      <div class="" style="padding-left: 5px; padding-right: 5px">
        <table class="highlight">
          <thead>
          <tr>
            <table style="position: relative">
              <tr>
                <th>ITENS</th>
                <th class="right">VALOR</th>
              </tr>
            </table>
          </tr>
          </thead>
          <tbody>
          <tr v-for="pedido in this.$store.state.pedido.itens">
            <!-- Produto -->
            <table style="position: relative; height: 40px">
              <tr>
                <td style="width: 65%">
                  {{
                    LimitarCaracteres(
                      pedido.quantidade + "x " + pedido.produto.nome,
                      25
                    )
                  }}
                </td>
                <td class="right" style="padding-top: 7px">
                  R$
                  {{
                    parseFloat(
                      pedido.produto.valor * pedido.quantidade
                    ).toFixed(2)
                  }}
                  <a
                    @click="RemoverItem(pedido)"
                    class="btn-small"
                    style="padding: 0px 1px 1px 1px; margin: 0px"
                  ><i class="material-icons grey" style="font-size: 15px"
                  >close</i
                  ></a
                  >
                </td>
              </tr>
            </table>

            <!-- Adicionais -->
            <table
              v-if="pedido.adicionais.length > 0"
              style="position: relative"
            >
              <tr v-for="adicional in pedido.adicionais">
                <td>
                  &nbsp;&nbsp;
                  {{
                    LimitarCaracteres(
                      " " +
                      (adicional.quantidade == (undefined || 0)
                        ? 1
                        : adicional.quantidade || 1) *
                      pedido.quantidade +
                      "x" +
                      " " +
                      adicional.nome,
                      25
                    )
                  }}
                </td>
                <td class="right" style="">
                  R$
                  {{
                    parseFloat(
                      adicional.valor *
                      (adicional.quantidade == (undefined || 0)
                        ? 1
                        : adicional.quantidade || 1) *
                      pedido.quantidade
                    ).toFixed(2)
                  }}
                  <a
                    @click="RemoverAdicional(pedido, adicional)"
                    class="btn-small"
                    style="padding: 0px 1px 1px 1px; margin: 0px"
                  ><i class="material-icons grey" style="font-size: 15px"
                  >close</i
                  ></a
                  >
                </td>
              </tr>
            </table>

            <!-- Grades -->
            <table v-if="pedido.grades.grade" style="position: relative">
              <tr>
                <td>
                  &nbsp;&nbsp;
                  {{
                    LimitarCaracteres(
                      " " + "Tamanho: " + " " + pedido.grades.grade.tamanho,
                      25
                    )
                  }}
                </td>
              </tr>
            </table>

            <!-- Cores -->
            <table v-if="GetNomeCor(pedido.cores)" style="position: relative">
              <tr>
                <td>
                  &nbsp;&nbsp;
                  {{
                    LimitarCaracteres(" " + "Cor: " + " " + pedido.cores.cor.nome, 25)
                  }}
                </td>
              </tr>
            </table>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <table style="position: relative; height: auto">
              <tr>
                <th>TOTAL</th>
                <td class="right">
                    <span v-if="this.valor_desconto == 0.0">
                      R$
                      {{
                        parseFloat(
                          this.$store.getters.getValorTotalPedido
                        ).toFixed(2)
                      }}
                    </span>
                  <span v-else>
                      <strike
                      >R$
                        {{
                          parseFloat(
                            this.$store.getters.getValorTotalPedido
                          ).toFixed(2)
                        }}</strike
                      >
                      R$
                      {{
                      parseFloat(
                        this.$store.getters.getValorTotalPedido -
                        valor_desconto
                      ).toFixed(2)
                    }}
                    </span>
                </td>
              </tr>
            </table>
          </tr>
          </tfoot>
        </table>
      </div>
    </div>

    <div class="content-e">
      <router-link
        :to="'/' + this.$store.state.empresa_url + '/menu'"
        class="waves-effect waves-light btn-small btn-large"
        :style="'background-color: ' + this.$store.state.empresa.cor_primaria"
      >Acrescentar mais itens</router-link
      >
    </div>

    <div class="bloco" >
      <titulo-destacado
        :fundo="'white'"
        titulo="Como deseja receber o pedido?"
        :style="
          'border-style: solid;border-width: 1px;border-color: ' +
          this.$store.state.empresa.cor_primaria +
          ';color:' +
          this.$store.state.empresa.cor_primaria
        "
      ></titulo-destacado>
      <div class="bloco-lista">
        <div class="col" style="padding-top: 10px">
          <label style="">
            <input
              name="envio"
              value="ENTREGA"
              type="radio"
              v-model="forma_entrega"
            />
            <span
            >Entrega &nbsp;&nbsp;<span style="font-weight: 500">{{
                this.$store.state.empresa.forma_cobranca_frete != "BAIRRO"
                  ? "Taxa: " + this.taxa_entrega_v2
                  : ""
              }}</span
            ><br />(Podendo haver cobrança de taxas)</span
            >
          </label>
        </div>

        <div
          v-if="this.$store.state.empresa.retirar_local == 'S'"
          class="col"
          style="padding-top: 10px"
        >
          <label style="">
            <input
              name="envio"
              value="RETIRADA"
              type="radio"
              v-model="forma_entrega"
            />
            <span>Retirada<br />(Verificar disponibilidade)</span>
          </label>
        </div>
      </div>
    </div>

    <div class="bloco" v-if="this.forma_entrega == 'ENTREGA'">
      <titulo-destacado
        :fundo="'white'"
        titulo="Endereço de Entrega"
        :style="
          'border-style: solid;border-width: 1px;border-color: ' +
          this.$store.state.empresa.cor_primaria +
          ';color:' +
          this.$store.state.empresa.cor_primaria
        "
      >
        <span
          v-if="!this.endereco_entrega_valido"
          class="valid-badge new badge cor-primaria-bg"
          data-badge-caption=""
          :style="'background-color: ' + this.$store.state.empresa.cor_primaria"
        >Obrigatório</span
        >
        <span v-else class="valid-check material-icons md-38 cor-primaria-text"
        >check_circle_outline</span
        >
      </titulo-destacado>

      <div class="bloco-lista">
        <div
          v-for="endoff in enderecos_offline"
          class="col"
          style="padding-top: 10px"
        >
          <div class="row" v-if="endoff">
            <div class="col s10">
              <label>
                <input
                  class="right"
                  type="radio"
                  :name="endoff"
                  :value="endoff"
                  v-model="endereco_offiline_selecionado"
                  @click="LimparEndereco()"
                  @change="
                    CalcularFrete(
                      'bairro=' + endereco_offiline_selecionado.bairro_id
                    )
                  "
                  style="display: inherit"
                />
                <span>
                  <strong>{{
                      endoff.endereco +
                      (endoff.numero ? ", " + endoff.numero : "") +
                      (endoff.complemento ? ", " + endoff.complemento : "")
                    }}</strong
                  >, {{ endoff.bairro_nome }}, {{ endoff.cidade_nome }}/{{
                    endoff.uf
                  }}{{ endoff.cep ? ", CEP:" + endoff.cep : "" }}
                </span>
              </label>
            </div>
            <div class="col s2">
              <i
                class="material-icons red-text"
                @click="RemoverEndereco(endoff)"
              >delete_forever</i
              >
            </div>
          </div>
        </div>
        <div class="content-e col" style="padding-top: 10px">
          <button
            class="waves-effect waves-light btn-small"
            @click="NovoEndereco()"
            :style="
              'background-color: ' + this.$store.state.empresa.cor_primaria
            "
          >
            Novo Endereço
          </button>
        </div>
      </div>
      <hr />

      <div class="bloco-lista" v-if="novo_endereco">
        <div class="">
          <div class="col">
            <div class="switch">
              <label>
                Não tenho o CEP
                <input type="checkbox" v-model="nao_tem_cep" />
                <span class="lever"></span>
              </label>
            </div>
          </div>
        </div>
        <div class="row" style="margin-bottom: 0px">
          <div
            class="input-field col s10"
            style="padding: 0 0rem 0 0"
            v-if="!nao_tem_cep"
          >
            <input
              id="cep"
              placeholder="Digite seu CEP "
              v-model="endereco.cep"
              type="number"
              value=""
              maxlength="8"
              min="8"
              max="8"
              class="validate"
              style="left: 0px"
              v-on:input="maxLengthCheck()"
              v-on:blur="PesquisarCep()"
            />
            <label for="cep" style="padding-left: 0px; left: 0.01rem"></label>
          </div>
          <div
            class="col s2"
            style="padding: 19px 0rem 0 0"
            v-if="!nao_tem_cep"
          >
            <a
              class="waves-effect waves-light btn-small"
              :style="
                'background-color: ' + this.$store.state.empresa.cor_primaria
              "
            ><span style="font-weight: 700"
            ><i class="material-icons">search</i></span
            ></a
            >
          </div>
          <span
            v-if="
              nao_tem_cep ||
              (endereco.cep != '' &&
                endereco.cep.length == 8 &&
                endereco.cidade_nome != '')
            "
          >
            <div class="input-field col s8" style="padding: 0 0rem 0 0">
              <input
                id="endereco"
                v-model="endereco.endereco"
                type="text"
                class="validate"
                style="left: 0px"
                placeholder="Endereço"
              />
              <label
                for="endereco"
                style="padding-left: 0px; left: 0.01rem"
              ></label>
            </div>
            <!-- <div class="input-field col s4" style="padding: 0 0.7rem">
              <input
                id="s"
                type="number"
                v-model="endereco.numero"
                class="validate"
                placeholder="Número"
              />
              <label for="s"></label>
            </div> -->
            <div class="input-field col s4" style="padding: 0 0.70rem;">
            <input autocomplete="off" id="s_numero" type="number" v-model="endereco.numero" class="validate"
                   placeholder="Número" @blur="CalcularFrete('')">
            <label for="s_numero" class="grey-text text-darken-4"></label>
          </div>
          </span>
        </div>

        <span
          v-if="
            nao_tem_cep ||
            (endereco.cep != '' &&
              endereco.cep.length == 8 &&
              endereco.cidade_nome != '')
          "
        >
          <div class="row" style="margin-bottom: 0px">
            <div class="input-field col s6" style="padding: 0 0rem 0 0">
              <span
                v-if="
                  this.$store.state.empresa.forma_cobranca_frete != 'BAIRRO'
                "
              >
                <input
                  id="bairro"
                  type="text"
                  v-model="endereco.bairro"
                  class="validate"
                  style="left: 0px"
                  placeholder="Bairro"
                />
                <label
                  for="bairro"
                  style="padding-left: 0px; left: 0.01rem"
                ></label>
              </span>

              <select
                v-if="
                  this.$store.state.empresa.forma_cobranca_frete == 'BAIRRO'
                "
                class="browser-default"
                @change="SelecionarBairro()"
                v-model="bairro_id"
                :disabled="!nao_tem_cep ? '' : disabled"
              >
                <option value="" disabled selected>Selecione um Bairro</option>
                <option
                  v-for="bairrofrete in this.$store.state.empresa
                    .tarifas_entrega_bairro"
                  :value="bairrofrete.bairro_id"
                  :id="'selectbairro' + bairrofrete.bairro_id"
                  :data-nome="bairrofrete.bairro.bairro"
                >
                  {{ bairrofrete.bairro.bairro }}
                </option>
              </select>
            </div>
            <div class="input-field col s6" style="padding: 0 0.7rem">
              <input
                id="complemento"
                v-model="endereco.complemento"
                type="text"
                class="validate"
                placeholder="Complemento"
              />
              <label for="complemento"></label>
            </div>
          </div>

          <div class="row">
            <div class="input-field col s3" style="padding: 0 0rem 0 0">
              <input
                id="estado"
                type="text"
                v-model="endereco.uf"
                class="validate"
                style="left: 0px"
                placeholder="UF"
              />
              <label
                for="estado"
                style="padding-left: 0px; left: 0.01rem"
              ></label>
            </div>
            <div class="input-field col s9" style="padding: 0 0.7rem">
              <input
                id="cidade"
                v-model="endereco.cidade_nome"
                type="text"
                placeholder="Cidade"
                class="validate"
                style="left: 0px"
              />
              <label for="cidade"></label>
            </div>
          </div>
        </span>
      </div>
    </div>

    <div class="bloco" >
      <titulo-destacado
        :fundo="'white'"
        titulo="Forma de Pagamento"
        :style="
          'border-style: solid;border-width: 1px;border-color: ' +
          this.$store.state.empresa.cor_primaria +
          ';color:' +
          this.$store.state.empresa.cor_primaria
        "
      ></titulo-destacado>
      <div class="bloco-lista">
        <div
          class="col"
          style="padding-top: 10px"
          v-if="this.$store.state.empresa.pagamento_dinheiro == 'S'"
        >
          <label style="">
            <input
              value="DINHEIRO"
              type="radio"
              v-model="forma_pagamento"
              @click="CalcularDesconto($event, 'DINHEIRO')"
            />
            <span>Dinheiro</span>
          </label>
          <a
            class="btn right"
            :style="
              'padding: 4px; margin: 1px;background-color: ' +
              this.$store.state.empresa.cor_primaria
            "
            v-if="forma_pagamento == 'DINHEIRO'"
            @click="precisa_troco = !precisa_troco"
          >{{
              precisa_troco ? "Não precisa de troco" : "Preciso de troco"
            }}</a
          >
        </div>
        <div class="col" style="padding-top: 10px" v-if="(this.$store.state.empresa.pagamento_paghiper_pix == 'S') && (this.$store.state.empresa.modulo_paghiper_status == 'ATIVO')">
          <label style="">
            <input value="PAGHIPER_PIX" type="radio" class="with-gap" v-model="forma_pagamento"
                   @click="precisa_troco = false; CalcularDesconto($event, 'PAGHIPER_PIX');"/>
            <span>PIX Online</span>
          </label>
        </div>
        <div class="col" style="padding-top: 10px" v-if="(this.$store.state.empresa.pagamento_mercadopagolink == 'S') && (this.$store.state.empresa.modulo_mercadopago_status == 'ATIVO')">
          <label class="">
            <input value="MERCADOPAGOLINK" type="radio" class="with-gap" v-model="forma_pagamento"  @click="precisa_troco = false"/>
            <span>Pagamento com Link Online</span>
          </label>
        </div>
        <div
          class="col"
          style="padding-top: 10px"
          v-if="this.$store.state.empresa.pagamento_debito == 'S'"
        >
          <label style="">
            <input
              value="DEBITO"
              type="radio"
              v-model="forma_pagamento"
              @click="
                precisa_troco = false;
                CalcularDesconto($event, 'DEBITO');
              "
            />
            <span>Cartão de Débito</span>
          </label>
        </div>
        <div
          class="col"
          style="padding-top: 10px"
          v-if="this.$store.state.empresa.pagamento_credito == 'S'"
        >
          <label style="">
            <input
              value="CREDITO"
              type="radio"
              v-model="forma_pagamento"
              @click="
                precisa_troco = false;
                CalcularDesconto($event, 'CREDITO');
              "
            />
            <span>Cartão de Crédito</span>
          </label>
        </div>
        <div class="col" style="padding-top: 10px" v-if="(this.$store.state.empresa.pagamento_softexpress_cartao == 'S') && (this.$store.state.empresa.modulo_softexpress_status == 'ATIVO')">
          <label>
            <input value="SOFTEXPRESS_CARTAO" type="radio" class="with-gap" v-model="forma_pagamento"
                   @click="precisa_troco = false; CalcularDesconto($event, 'SOFTEXPRESS_CARTAO');"/>
            <span>Cartão de Crédito Online</span>
          </label>
        </div>
        <div class="col" style="padding-top: 10px"
          v-if="this.$store.state.empresa.pagamento_transferencia == 'S'">
          <label style="">
            <input value="TRANSFERENCIA" type="radio" v-model="forma_pagamento" @click="precisa_troco = false; CalcularDesconto($event, 'TRANSFERENCIA');"/>
            <span>Transferência</span>
          </label>
        </div>
        <div class="col" style="padding-top: 10px" v-if="this.$store.state.empresa.pagamento_boleto == 'S'">
          <label style="">
            <input value="BOLETO" type="radio" v-model="forma_pagamento" @click="precisa_troco = false; CalcularDesconto($event, 'BOLETO');"/>
            <span>Boleto</span>
          </label>
        </div>
        <div class="col" style="padding-top: 10px" v-if="this.$store.state.empresa.pagamento_pix == 'S'">
          <label style="">
            <input value="PIX" type="radio" v-model="forma_pagamento" @click=" precisa_troco = false; CalcularDesconto($event, 'PIX');"/>
            <span>Pix</span>
          </label>
        </div>
      </div>
    </div>

    <div class="bloco"  v-if="precisa_troco">
      <titulo-destacado
        :fundo="'white'"
        titulo="Troco para quanto?"
        :style="
          'border-style: solid;border-width: 1px;border-color: ' +
          this.$store.state.empresa.cor_primaria +
          ';color:' +
          this.$store.state.empresa.cor_primaria
        "
      >
        <span
          v-if="!this.troco_valido"
          class="valid-badge new badge cor-primaria-bg"
          data-badge-caption=""
          :style="'background-color: ' + this.$store.state.empresa.cor_primaria"
        >Obrigatório</span
        >
        <span v-else class="valid-check material-icons md-38 cor-primaria-text"
        >check_circle_outline</span
        >
      </titulo-destacado>
      <div class="bloco-lista">
        <div class="input-field col s8" style="padding: 0 0rem 0 0">
          <money id="troco_valor" v-model="troco_para_quanto"></money>
          <label
            for="troco_valor"
            class="grey-text text-darken-4"
            style="padding-left: 0px; left: 0.01rem"
          ></label>
        </div>
      </div>
    </div>

    <!-- //pix -->
    <bloco v-if="this.forma_pagamento == 'PIX'">
      <div class="bloco" >
        <titulo-destacado
        :fundo="'white'"
        titulo="Dados do PIX"
        :style="
          'border-style: solid;border-width: 1px;border-color: ' +
          this.$store.state.empresa.cor_primaria +
          ';color:' +
          this.$store.state.empresa.cor_primaria
        "
      >
        </titulo-destacado>

        <div class="bloco-lista">
          <div class="col" style="padding-top: 8px">
            <div class="row">
              <div class="col s12">
                <label class="grey-text text-darken-4">
                  <span>
                    <strong>PIX - Tipo:</strong> &nbsp;&nbsp; {{ this.$store.state.empresa.pagamento_pix_chave_tipo }}
                    <span>
                      <br><br>
                      <strong>PIX - Chave Pagamento:</strong> <hr>
                      <input type="text" :value="this.$store.state.empresa.pagamento_pix_chave" id="myInput" readonly>
                      <button @click="myFunction()">Copiar</button>
                    </span>
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </bloco>

     <bloco v-if="this.forma_pagamento == 'TRANSFERENCIA' && this.contas.length > 0">
      <div class="bloco" >
        <titulo-destacado :fundo="'white'" titulo="Selecione uma conta" :style=" 'border-style: solid;border-width: 1px;border-color: ' + this.$store.state.empresa.cor_primaria +';color:' +this.$store.state.empresa.cor_primaria">
            <span
              v-if="!this.conta_bancaria"
              class="valid-badge new badge cor-primaria-bg"
              data-badge-caption=""
              :style="'background-color: ' + this.$store.state.empresa.cor_primaria"
            >Obrigatório</span
            >
            <span v-else class="valid-check material-icons md-38 cor-primaria-text"
            >check_circle_outline</span
            >
          </titulo-destacado>

          <div class="bloco-lista">
            <div v-for="conta in this.contas" :key="conta.id" class="col" style="padding-top: 8px">
              <div class="row" v-if="conta.ativo == 'S'" >
                <div class="col s12">
                <label class="grey-text text-darken-4">
                    <input class="right with-gap" type="radio" :name="'ct'+conta.nome" :value="conta" v-model="conta_bancaria" style="display: inherit;" />
                    <span>
                        <strong>{{conta.banco.nome}} ({{conta.banco.codigo}})</strong>
                        <br>
                        TIPO CONTA: &nbsp;&nbsp;{{conta.tipo_conta}}

                        <span v-if="conta.informacoes_adicionais">
                          <br>
                        OBSERVAÇÕES: &nbsp;&nbsp;{{conta.informacoes_adicionais}}
                        </span>
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          </div>
    </bloco>

    <div class="bloco" >
      <titulo-destacado
        :fundo="'white'"
        titulo="Informe seus dados"
        :style="
          'border-style: solid;border-width: 1px;border-color: ' +
          this.$store.state.empresa.cor_primaria +
          ';color:' +
          this.$store.state.empresa.cor_primaria
        "
      >
        <span
          v-if="!this.dados_pessoa_valido"
          class="valid-badge new badge cor-primaria-bg"
          data-badge-caption=""
          :style="'background-color: ' + this.$store.state.empresa.cor_primaria"
        >Obrigatório</span
        >
        <span v-else class="valid-check material-icons md-38 cor-primaria-text"
        >check_circle_outline</span
        >
      </titulo-destacado>
      <div class="bloco-lista">
        <div class="input-field col s8" style="padding: 0 0rem 0 0">
          <input
            id="nome_cliente"
            v-model="nome_cliente"
            type="text"
            class="validate"
            style="left: 0px"
            placeholder="Seu nome..."
          />
          <label
            for="nome_cliente"
            style="padding-left: 0px; left: 0.01rem"
          ></label>
        </div>

        <!-- <div class="input-field col s8" style="padding: 0 0rem 0 0">
          <the-mask
            id="telefone"
            v-model="telefone"
            type="tel"
            masked="true"
            :mask="['(##) ####-####', '(##) #####-####']"
            placeholder="Seu Telefone..."
          />
          <label
            for="telefone"
            style="padding-left: 0px; left: 0.01rem"
          ></label>
        </div> -->
        <div class="input-field col s8" style="padding: 0 0rem 0 0;">
          <the-mask id="telefone" v-model="telefone" type="tel" :masked="true"
                    :mask="['(##) ####-####','(##) #####-####']" placeholder="Seu Telefone..."/>
          <label for="telefone" style="padding-left: 0px; left: 0.01rem"></label>
        </div>
        <div
          class=""
          v-if="this.$store.state.empresa.perguntar_cpf_nota == 'S'"
        >
          <div class="col" v-if="this.$store.state.empresa.cpf_obrigatorio != 'S'">
            <div class="switch">
              <label>
                CPF na nota?
                <input type="checkbox" v-model="cpf_nota" />
                <span class="lever"></span>
              </label>
            </div>
          </div>
        </div>

        <div
          class="input-field col s8"
          style="padding: 0 0rem 0 0"
          v-if="cpf_nota"
        >
          <the-mask
            id="cpf"
            v-model="cpf"
            t
            :mask="['###.###.###-##']"
            placeholder="Seu CPF..."
          />
          <label for="cpf" style="padding-left: 0px; left: 0.01rem"></label>
        </div>
      </div>

    </div>

    <bloco v-if="this.forma_pagamento == 'SOFTEXPRESS_CARTAO'" id="SOFTEXPRESS_CARTAO_CAIXA_PAGAMENTO" >
      <div class="bloco">
        <div class="input-field" style="padding: 0 0rem 0 0;">
          <titulo-destacado :fundo="'white'" titulo="Pagamento Cartão Online" :style=" 'border-style: solid;border-width: 1px;border-color: ' + this.$store.state.empresa.cor_primaria +';color:' +this.$store.state.empresa.cor_primaria">
              <span
                class="valid-badge new badge cor-primaria-bg"
                data-badge-caption=""
                :style="'background-color: ' + this.$store.state.empresa.cor_primaria"
              >Obrigatório</span
              >
          </titulo-destacado>
          <SoftwareExpressCheckoutTransparente></SoftwareExpressCheckoutTransparente>
          <center>
            <strong style="color: #bdbdbd;font-size: 12px;">Aguardando pagamento...</strong><br>
            <img height="100" src="@/assets/aguardando.gif"/>
          </center>
        </div>
      </div>
    </bloco>

    <bloco v-if="this.forma_pagamento == 'PAGHIPER_PIX'" id="PAGHIPER_PIX_CAIXA_PAGAMENTO" style="display: none">
      <div class="bloco">
        <titulo-destacado :fundo="'white'" titulo="Dados do PIX Online" :style=" 'border-style: solid;border-width: 1px;border-color: ' + this.$store.state.empresa.cor_primaria +';color:' +this.$store.state.empresa.cor_primaria">
          <span class="valid-check material-icons md-38 cor-primaria-text">check_circle_outline</span>
        </titulo-destacado>
        <div class="bloco-lista">
          <div class="col" style="padding-top: 8px">
            <div class="row">
              <div class="col s12">
                <label class="grey-text text-darken-4">
                  <span>
                    <span>
                      <center>
                        <div class=" max-width: 100%;">
                          <p style="padding: 5px; word-wrap: break-word;font-size: small; user-select: text;">
                            {{ this.paghiper_pix.codigo_copia_cola }}
                          </p>
                        </div>
                        <button @click="CopiarParaAreaDeTransferenciaChavePix()">Copiar Código </button>
                        <br>
                        <img style="padding-top: 7px;max-width: 75%" alt="Código pagamento PIX Online"
                            :src="'data:image/png;base64,' + this.paghiper_pix.imagem_qrcode"/>
                    </center>
                    </span>
                    <center>
                        <strong style="color: #bdbdbd;font-size: 12px;">Aguardando pagamento...</strong><br>
                        <img height="100" src="@/assets/aguardando.gif"/>
                    </center>
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </bloco>



    <br>
      <br>
      <br>
      <br>

    <caixa-flutuante-inferior v-if="forma_pagamento == 'SOFTEXPRESS_CARTAO'" altura="70" estilo="width: 100%; background-color: white; font-weight: bold; max-width: 800px; padding: .5em">
        <a @click="RealizarPagamentoSoftExpressCartao()" style="width: 100%"
           :class="'waves-effect waves-light btn-large btn-enviar cor-primaria-bg' + (!PedidoValido() || this.softexpress_cartao.pagamento_realizado ? ' disabled' : '')">
          <span>Confirmar Pagamento</span> R$ {{ ObterValorTotalAtualizadoDoPedido() }}
        </a>
    </caixa-flutuante-inferior>
    <caixa-flutuante-inferior v-else-if="forma_pagamento == 'PAGHIPER_PIX' && this.paghiper_pix.pagamento_realizado == false" altura="70"
                                estilo="width: 100%; background-color: white; font-weight: bold; max-width: 800px; padding: .5em">
        <a @click="RealizarPagamentoPagHiperPix()" style="width: 100%"
           :class="'waves-effect waves-light btn-large btn-enviar cor-primaria-bg' + (!PedidoValido() || this.paghiper_pix.gerado ? ' disabled' : '')">
          <span>{{ this.paghiper_pix.gerado ? 'Aguardando' : 'Realizar' }} Pagamento</span> R$ {{ ObterValorTotalAtualizadoDoPedido() }}
        </a>
    </caixa-flutuante-inferior>
    <caixa-flutuante-inferior v-else altura="70" style="background-color: white">
      <a
        v-if="!PedidoValido()"
        class="waves-effect waves-light btn-large disabled"
        style="width: 100%"
      >
        Enviar Pedido &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <span style="font-weight: 700">
          R$
          {{
            (parseFloat(this.$store.getters.getValorTotalPedido - this.valor_desconto) + (forma_entrega == 'ENTREGA' ? parseFloat(this.$store.state.empresa.taxa_entrega) : 0)).toFixed(2)
          }}
        </span>
      </a>

      <a
        v-if="PedidoValido()"
        class="waves-effect waves-light btn-large"
        @click="EnviarPedido()"
        :style="
          'width: 100%;background-color:' +
          this.$store.state.empresa.cor_primaria
        "
      >
        Enviar Pedido &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <span style="font-weight: 700">
          R$
          {{
            (parseFloat(this.$store.getters.getValorTotalPedido - this.valor_desconto) + (forma_entrega == 'ENTREGA' ? parseFloat(this.$store.state.empresa.taxa_entrega) : 0)).toFixed(2)
          }}
        </span>
      </a>
    </caixa-flutuante-inferior>
  </div>
</template>

<script>
import MenuSuperior from "./template/MenuSuperior";
import TituloDestacado from "./template/TituloDestacado";
import CaixaFlutuanteInferior from "../components/CaixaFlutuanteInferior";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Swal from "sweetalert2";
import { WMCompose, WMSend } from "@aninga/whatsapp-manager";
import { ValidarCPF } from "validadorjs";
import axios from "axios";
import SecureLS from "secure-ls";
import {
  CalcularFretePorBairroId,
  ObterBairroIdPorBairroNome, ObterBairroPorBairroId,
  ObterEnderecoPorCep, ObterValorFretePorPeso,
  ValidarCEP,
  ObterValorFretePorKm
} from "../../services/frete";
import SoftwareExpressCheckoutTransparente from "../components/Widgets/SoftwareExpressCheckoutTransparente.vue";
// import momentTm from 'moment-timezone';

export default {
  name: "OrderView",
  data() {
    return {
      contas: this.$store.state.empresa.contas,
      conta_bancaria: null,
      link_pagamento: '',
      link_pagamento_chave_rastreamento:'',
      numero_pedido: 0,
      codigo_rastreamento: "",
      pedido_enviado: false,
      taxa_entrega_v2: "",
      bairro_id: "",
      nao_tem_cep: false,
      nome_cliente: "",
      precisa_troco: false,
      cpf_nota: false,
      cpf: "",
      telefone: "",
      troco_para_quanto: 0,
      forma_pagamento: "DINHEIRO",
      forma_entrega: "ENTREGA",
      formasDePagamentos: this.$store.state.empresa.desconto,

      endereco: {
        cep: "",
        endereco: "",
        numero: "",
        bairro: "",
        complemento: "",
        uf: this.$store.state.empresa.estado,
        cidade_nome: "",
        salvo_local: false,
      },
      isLoading: false,
      fullPage: true,
      enderecos_offline: [
        {
          cep: "",
          endereco: "",
          numero: "",
          bairro: "",
          bairro_id: "",
          complemento: "",
          uf: "",
          cidade_nome: "",
        },
      ],
      endereco_offiline_selecionado: null,
      novo_endereco: false,
      endereco_entrega_valido: false,
      troco_valido: false,
      dados_pessoa_valido: false,
      valor_desconto: 0.0,
      total_desconto: 0,
      valor_total: (
        parseFloat(this.$store.getters.getValorTotalPedido) +
        (this.forma_entrega == "ENTREGA"
          ? parseFloat(this.$store.state.empresa.taxa_entrega)
          : 0)
      ).toFixed(2),
      softexpress_cartao:{
        pagamento_realizado: false,
        pagamento_chave_rastreamento:""
      },
      _paghiper_checar_pagamento_intervalo: null,
      paghiper_pix:{
        gerado: false,
        pagamento_realizado: false,
        codigo_copia_cola: "",
        imagem_qrcode: "",
        chave_rastreamento:""
      }
    };
  },
  components: {
    SoftwareExpressCheckoutTransparente,
    CaixaFlutuanteInferior,
    TituloDestacado,
    MenuSuperior,
    Loading,
  },
  mounted() {
    window.scrollTo(0, 0);
    $(document).ready(function () {
      $("select").formSelect();
    });
    if (this.$store.state.pedido.itens.length == 0) {
      this.$router.push(
        "/" + this.$router.currentRoute.params.empresa + "/menu"
      );
    }
    document.getElementById("bodyMain").style = "background-color: white";

    if (this.$store.state.empresa.forma_cobranca_frete != "BAIRRO") {
      this.taxa_entrega_v2 = this.$store.state.empresa.taxa_entrega;
      if (this.taxa_entrega_v2 == "0.00") {
        this.taxa_entrega_v2 = "A combinar";
      }
    } else {
      this.$store.state.empresa.taxa_entrega = 0;
    }
    //carregar enderecos offline
    var ls = new SecureLS();
    var enderecos = ls.get("enderecos");
    this.enderecos_offline = enderecos;

    var dados_cliente = ls.get("dados_cliente");
    if (dados_cliente) {
      this.nome_cliente = dados_cliente.nome_cliente;
      this.telefone = dados_cliente.telefone;
      this.cpf_nota = dados_cliente.cpf_nota;
      this.cpf = dados_cliente.cpf;
    }

    this.CalcularDesconto();

    this.cpf_nota = this.$store.state.empresa.cpf_obrigatorio == 'S' ? true : false;

    // moment.tz.setDefault("America/Porto_Velho")
  },
  methods: {
    GetNomeCor(obj){
      console.log('obj')
      console.log(obj)
      if(obj != null){
        if(obj.cor != undefined){
          return true;
        }else{
          return false;
        }
      }else{
        return false;
      }

    }, //forma_pagamento
    FormatarFormaPagamento(forma) {
      let formaPagemento = forma;
      switch (formaPagemento) {
        case 'VALE_ALIMENTACAO':
          formaPagemento = 'Vale Alimentação'
          break;
        case 'VALE_REFEICAO':
          formaPagemento = 'Vale Refeição'
          break;
        case 'PAGHIPER_PIX':
          formaPagemento = 'PIX Online'
          break;
        case 'SOFTEXPRESS_CARTAO':
          formaPagemento = 'Cartão de Crédito - Final: ***' + $('#softwareExpressNumero').val().slice(-4)
          break;
      }
      return formaPagemento;
    },
    CopiarParaAreaDeTransferenciaChavePix() {
      const input = document.createElement('input');

      if(this.forma_pagamento == 'PAGHIPER_PIX')
        input.value = this.paghiper_pix.codigo_copia_cola;

      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      alert('Código copiado! Aguardando pagamento...');
    },
    ObterValorTotalAtualizadoDoPedido() {
      return (parseFloat(this.$store.getters.getValorTotalPedido - this.valor_desconto) + (this.forma_entrega == 'ENTREGA' ? parseFloat(this.$store.state.empresa.taxa_entrega) : 0)).toFixed(2);
    },
    RealizarPagamentoPagHiperPix() {
      this.isLoading = true;
      $.ajax({
        url: this.$store.state.apiUrl + "empresa/" + this.$store.state.empresa_url + '/pagamento/pix-paghiper/' + this.ObterValorTotalAtualizadoDoPedido(),
        type: "GET",
        success: (data) => {
          this.paghiper_pix.gerado = true;
          this.paghiper_pix.codigo_copia_cola = data.codigo_copia_cola;
          this.paghiper_pix.imagem_qrcode = data.imagem_qrcode;
          this.paghiper_pix.chave_rastreamento = data.chave_rastreamento;
          this.isLoading = false;
          $("#PAGHIPER_PIX_CAIXA_PAGAMENTO").show();
          setTimeout(() => {
            document.getElementById("PAGHIPER_PIX_CAIXA_PAGAMENTO").scrollIntoView({behavior: 'smooth'});

            this._paghiper_checar_pagamento_intervalo = setInterval(this.ConsultarStatusPagamentoPagHiper, 15000);
            setTimeout(() => {
              clearInterval(this._paghiper_checar_pagamento_intervalo);
              console.log("Intervalo interrompido após um período.");
            }, 300000);

          }, 500);
        },
        error: (data) => {
          this.isLoading = false;
          this.paghiper_pix.gerado = false;
          let erro = "Erro ao gerar PIX para pagamento :(";
          if (data.status < 500 && data.responseJSON.length > 0) {
            erro = data.responseJSON[0];
          }
          Swal.fire({
            title: 'Aviso!',
            text: erro,
            icon: 'error',
            customClass: {confirmButton: 'confirm-button-class materialize-red'}
          });
        }
      });
    },
    RealizarPagamentoSoftExpressCartao()
    {
      this.isLoading = true;
      $.ajax({
            url: this.$store.state.apiUrl + "empresa/" + this.$store.state.empresa_url + '/pagamento/cartao-softexpress',
            data: {
              softwareExpressNome: $('#softwareExpressNome').val(),
              softwareExpressMesAno: $('#softwareExpressMesAno').val(),
              softwareExpressNumero: $('#softwareExpressNumero').val(),
              softwareExpressCVC: $('#softwareExpressCVC').val(),
              softwareExpressBandeira: $('#softwareExpressBandeira').val(),
              softwareExpressValor: this.ObterValorTotalAtualizadoDoPedido(),
            },
            type: "POST",
            success: (data) => {
              this.isLoading = false;
              this.softexpress_cartao.pagamento_chave_rastreamento = data.chave_rastreamento;
              this.softexpress_cartao.pagamento_realizado = true;
              this.EnviarPedido()
            },
            error: (data) => {
              this.isLoading = false;
              var erro = "Erro ao realizar pagamento";
              if (data.responseJSON && data.responseJSON.message) {
                  erro = data.responseJSON.message;
              }
              Swal.fire({
                title: 'Aviso!',
                text: erro,
                icon: 'error',
                customClass: {confirmButton: 'confirm-button-class materialize-red'}
              });
          }
      });
    },
    ConsultarStatusPagamentoPagHiper() {
      let chaveRastreamento = this.paghiper_pix.chave_rastreamento;
      $.ajax({
        url: this.$store.state.apiUrl + "paghiper/consultar-pagamento-pix/" + chaveRastreamento,
        type: "GET",
        success: (data) => {
            if(data.status == 'PAGO'){
              this.paghiper_pix.pagamento_realizado = true;
              clearInterval(this._paghiper_checar_pagamento_intervalo);
              this.EnviarPedido()
            }
        },
        error: (data) => {

        }
      });
    },
    myFunction() {
      var copyText = document.getElementById("myInput");
      copyText.select();
      copyText.setSelectionRange(0, 99999); /* For mobile devices */
      document.execCommand("copy");
      alert("Chave copiada: " + copyText.value);
    },
    CalcularDesconto(e = null, opcao = "DINHEIRO") {

      this.formasDePagamentos = this.$store.state.empresa.desconto;
      var total = parseFloat(this.$store.getters.getValorTotalPedido);
      var desconto = typeof this.$store.state.empresa.desconto === 'string'
        ? JSON.parse(this.$store.state.empresa.desconto)
        : this.$store.state.empresa.desconto;

      var total = parseFloat(this.$store.getters.getValorTotalPedido);
      var total_qual_desconto = total;

      var novo_valor = 0.0;
      this.valor_desconto = 0.0;
      switch (opcao) {
        case "DINHEIRO":
          debugger
          if (
            desconto["DINHEIRO"]["ativo"] &&
            desconto["DINHEIRO"]["ativo"] == "S" &&
            desconto["DINHEIRO"]["forma_desconto"] &&
            desconto["DINHEIRO"]["forma_desconto"] != ""
          ) {
            switch (desconto["DINHEIRO"]["forma_desconto"]) {
              case "PRECO":
                var des_valor = parseFloat(
                  desconto["DINHEIRO"]["valor"]
                ).toFixed(2);
                total_qual_desconto = parseFloat(total_qual_desconto).toFixed(
                  2
                );
                if (total_qual_desconto > 0) {
                  this.valor_desconto = des_valor;
                }
                if (this.valor_desconto > 0) {
                  M.toast({
                    html: "Desconto de R$" + des_valor + " aplicado.",
                    displayLength: 3000,
                  });
                }
                break;
              case "PERCENTUAL":
                var valor_desconto =
                  (total_qual_desconto / 100) * desconto["DINHEIRO"]["valor"];
                var resultado = valor_desconto;
                this.valor_desconto = valor_desconto;
                if (this.valor_desconto > 0) {
                  M.toast({
                    html:
                      "Desconto de R$" +
                      this.valor_desconto.toFixed(2) +
                      " aplicado.",
                    displayLength: 3000,
                  });
                }
                break;
            }
          }
          break;

        case "DEBITO":
          if (
            desconto["DEBITO"]["ativo"] &&
            desconto["DEBITO"]["ativo"] == "S" &&
            desconto["DEBITO"]["forma_desconto"] &&
            desconto["DEBITO"]["forma_desconto"] != ""
          ) {
            switch (desconto["DEBITO"]["forma_desconto"]) {
              case "PRECO":
                var des_valor = parseFloat(desconto["DEBITO"]["valor"]).toFixed(
                  2
                );
                total_qual_desconto = parseFloat(total_qual_desconto).toFixed(
                  2
                );
                if (total_qual_desconto > 0) {
                  this.valor_desconto = des_valor;
                }
                if (this.valor_desconto > 0) {
                  M.toast({
                    html: "Desconto de R$" + des_valor + " aplicado.",
                    displayLength: 3000,
                  });
                }
                break;
              case "PERCENTUAL":
                var valor_desconto =
                  (total_qual_desconto / 100) * desconto["DEBITO"]["valor"];
                var resultado = valor_desconto;
                this.valor_desconto = valor_desconto;
                if (this.valor_desconto > 0) {
                  M.toast({
                    html:
                      "Desconto de R$" +
                      this.valor_desconto.toFixed(2) +
                      " aplicado.",
                    displayLength: 3000,
                  });
                }
                break;
            }
          }
          break;

        case "CREDITO":
          if (
            desconto["CREDITO"]["ativo"] &&
            desconto["CREDITO"]["ativo"] == "S" &&
            desconto["CREDITO"]["forma_desconto"] &&
            desconto["CREDITO"]["forma_desconto"] != ""
          ) {
            switch (desconto["CREDITO"]["forma_desconto"]) {
              case "PRECO":
                var des_valor = parseFloat(
                  desconto["CREDITO"]["valor"]
                ).toFixed(2);
                total_qual_desconto = parseFloat(total_qual_desconto).toFixed(
                  2
                );
                if (total_qual_desconto > 0) {
                  this.valor_desconto = des_valor;
                }
                if (this.valor_desconto > 0) {
                  M.toast({
                    html: "Desconto de R$" + des_valor + " aplicado.",
                    displayLength: 3000,
                  });
                }
                break;
              case "PERCENTUAL":
                var valor_desconto =
                  (total_qual_desconto / 100) * desconto["CREDITO"]["valor"];
                var resultado = valor_desconto;
                this.valor_desconto = valor_desconto;
                if (this.valor_desconto > 0) {
                  M.toast({
                    html:
                      "Desconto de R$" +
                      this.valor_desconto.toFixed(2) +
                      " aplicado.",
                    displayLength: 3000,
                  });
                }
                break;
            }
          }
          break;

        case "TRANSFERENCIA":
          if (
            desconto["TRANSFERENCIA"]["ativo"] &&
            desconto["TRANSFERENCIA"]["ativo"] == "S" &&
            desconto["TRANSFERENCIA"]["forma_desconto"] &&
            desconto["TRANSFERENCIA"]["forma_desconto"] != ""
          ) {
            switch (desconto["TRANSFERENCIA"]["forma_desconto"]) {
              case "PRECO":
                var des_valor = parseFloat(
                  desconto["TRANSFERENCIA"]["valor"]
                ).toFixed(2);
                total_qual_desconto = parseFloat(total_qual_desconto).toFixed(
                  2
                );
                if (total_qual_desconto > 0) {
                  this.valor_desconto = des_valor;
                }
                if (this.valor_desconto > 0) {
                  M.toast({
                    html: "Desconto de R$" + des_valor + " aplicado.",
                    displayLength: 3000,
                  });
                }
                break;
              case "PERCENTUAL":
                var valor_desconto =
                  (total_qual_desconto / 100) *
                  desconto["TRANSFERENCIA"]["valor"];
                var resultado = valor_desconto;
                this.valor_desconto = valor_desconto;
                if (this.valor_desconto > 0) {
                  M.toast({
                    html:
                      "Desconto de R$" +
                      this.valor_desconto.toFixed(2) +
                      " aplicado.",
                    displayLength: 3000,
                  });
                }
                break;
            }
          }
          break;

        case "BOLETO":
          if (
            desconto["BOLETO"]["ativo"] &&
            desconto["BOLETO"]["ativo"] == "S" &&
            desconto["BOLETO"]["forma_desconto"] &&
            desconto["BOLETO"]["forma_desconto"] != ""
          ) {
            switch (desconto["BOLETO"]["forma_desconto"]) {
              case "PRECO":
                var des_valor = parseFloat(desconto["BOLETO"]["valor"]).toFixed(
                  2
                );
                total_qual_desconto = parseFloat(total_qual_desconto).toFixed(
                  2
                );
                if (total_qual_desconto > 0) {
                  this.valor_desconto = des_valor;
                }
                if (this.valor_desconto > 0) {
                  M.toast({
                    html: "Desconto de R$" + des_valor + " aplicado.",
                    displayLength: 3000,
                  });
                }
                break;
              case "PERCENTUAL":
                var valor_desconto =
                  (total_qual_desconto / 100) * desconto["BOLETO"]["valor"];
                var resultado = valor_desconto;
                this.valor_desconto = valor_desconto;
                if (this.valor_desconto > 0) {
                  M.toast({
                    html:
                      "Desconto de R$" +
                      this.valor_desconto.toFixed(2) +
                      " aplicado.",
                    displayLength: 3000,
                  });
                }
                break;
            }
          }
          break;
        default:
          return 0.0;
      }
      if (this.forma_entrega == "ENTREGA") {
        this.CalcularFrete(this.endereco.bairro);
      }
    },
    NovoEndereco() {
      this.LimparEndereco();
      this.novo_endereco = !this.novo_endereco;
      this.endereco_offiline_selecionado = null;
    },
    SalvarEndereco() {
      var ls = new SecureLS();
      var enderecos = ls.get("enderecos");
      var endereco = {
        cep: this.endereco.cep,
        uf: this.endereco.uf,
        cidade_nome: this.endereco.cidade_nome,
        bairro_id: this.bairro_id,
        bairro_nome: this.endereco.bairro,
        endereco: this.endereco.endereco,
        numero: this.endereco.numero,
        complemento: this.endereco.complemento,
      };
      if (enderecos) {
        enderecos.push(endereco);
        ls.set("enderecos", enderecos);
      } else {
        enderecos = [];
        enderecos.push(endereco);
        ls.set("enderecos", enderecos);
      }
    },
    SalvarDados() {
      var ls = new SecureLS();

      ls.set("dados_cliente", {
        nome_cliente: this.nome_cliente,
        telefone: this.telefone,
        cpf_nota: this.cpf_nota,
        cpf: this.cpf,
      });
    },
    RemoverEndereco(itemRemover) {
      Swal.fire({
        title: "Aviso",
        text: " Deseja realmente remover este endereço ?",
        icon: "warning",
        customClass: {
          confirmButton: "confirm-button-class cor-primaria-bg",
        },
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Sim",
        showLoaderOnConfirm: true,
        preConfirm: () => {
          this.endereco_offiline_selecionado = null;
          this.LimparEndereco();

          var forDeletion = [];
          forDeletion.push(itemRemover);
          var enderecos = this.enderecos_offline.filter(
            (item) => !forDeletion.includes(item)
          );
          this.enderecos_offline = enderecos;
          var ls = new SecureLS();
          ls.set("enderecos", enderecos);

          return true;
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        if (result.value) {
          Swal.fire({
            title: "Sucesso",
            text: "Endereço removido",
            icon: "success",
            customClass: {
              confirmButton: "confirm-button-class cor-primaria-bg",
            },
          });
        }
      });
    },
    async SelecionarBairro() {
      var bairro = document.getElementById("selectbairro" + this.bairro_id);
      this.endereco.bairro = bairro.getAttribute("data-nome");
      if (this.$store.state.empresa.forma_cobranca_frete == "BAIRRO") {
        await this.CalcularFrete("bairro=" + this.bairro_id);
      }
    },
    async CalcularFrete(parametro) {
      this.isLoading = true;
      if ((this.$store.state.empresa.forma_cobranca_frete == 'BAIRRO') && (parametro != '')) {
        if (Number.isInteger(parametro)) {
          this.$store.state.empresa.taxa_entrega = CalcularFretePorBairroId(this.$store.state.empresa.tarifas_entrega_bairro, parametro)
          this.taxa_entrega_v2 = this.$store.state.empresa.taxa_entrega;

          var bairro = ObterBairroPorBairroId(this.$store.state.empresa.tarifas_entrega_bairro, parametro);
          this.endereco.uf = bairro.uf;
          this.endereco.cidade_nome = bairro.cidade;
          this.endereco.bairro = bairro.bairro;
          this.bairro_id = bairro.bairro_id;
          this.isLoading = false;
          this.taxa_entrega_calculo_mensagem_erro = false;

          M.toast({
            html: 'Taxa de entrega aplicada: R$ ' + this.$store.state.empresa.taxa_entrega,
            displayLength: 5000
          });
        } else {
          this.CalcularFretePorBairroNome(parametro);
        }

      }

      //this.isLoading = false;
      //return;

        if ((this.$store.state.empresa.forma_cobranca_frete == 'KM') || (this.$store.state.empresa.forma_cobranca_frete == 'FIXO_KM')) {

        this.isLoading = true;
        if (this.endereco.endereco && this.endereco.numero && this.endereco.bairro) {

          axios.post(this.$store.state.apiUrl + 'empresa/calcular-frete-por-geolocalizacao', {
            "empresa_usuario": this.$store.state.empresa.usuario_url,
            "endereco_entrega": this.endereco.endereco + ', ' + (this.endereco.numero || '') + ' - ' + this.endereco.bairro + ', ' + this.endereco.cidade_nome
          }).then(res => {
            this.isLoading = false;
            console.log(res)
            var taxa_frete = parseFloat(res.data.valor_frete).toFixed(2);
            if (this.taxa_entrega_old != taxa_frete) {
              this.$store.state.empresa.taxa_entrega = taxa_frete;
              this.taxa_entrega_old = taxa_frete;
              this.taxa_entrega_v2 = taxa_frete;
              M.toast({
                html: 'Taxa de entrega atualizada: R$ ' + this.$store.state.empresa.taxa_entrega,
                displayLength: 5000
              });
            }
            this.taxa_entrega_calculo_mensagem_erro = false;
          }).catch(error => {
            this.isLoading = false;
            M.toast({html: "<strong class='red-text'>Endereço inválido</strong>", displayLength: 4000});
            this.taxa_entrega_calculo_mensagem_erro = true;
            if (error.response.status == 404) {
              this.desativarEntrega(error.response.data)
            } else {
              M.toast({html: "<strong class='red-text'>" + error.response.data + "</strong>", displayLength: 4000});
            }
            return null;

          });
        }else{
          this.isLoading = false;
        }
      }

      if (this.$store.state.empresa.forma_cobranca_frete == 'TABELA_KM') {
        this.isLoading = true;
        if (this.endereco.endereco && this.endereco.numero && this.endereco.bairro) {
          axios.post(this.$store.state.apiUrl + 'empresa/calcular-distancia-entrega', {
            "empresa_usuario": this.$store.state.empresa.usuario_url,
            "endereco_entrega": this.endereco.endereco + ', ' + (this.endereco.numero || '') + ' - ' + this.endereco.bairro + ', ' + this.endereco.cidade_nome
          }).then(res => {
            console.log(res)
            this.taxa_entrega_calculo_mensagem_erro = false;
            this.isLoading = false;
            debugger;
            const valor = ObterValorFretePorKm(this.$store.state.empresa.tarifas_entreg_k_m, res.data.distancia_km);
            var taxa_frete = parseFloat(valor).toFixed(2);
            if (this.taxa_entrega_old != taxa_frete) {
              this.$store.state.empresa.taxa_entrega = taxa_frete;
              this.taxa_entrega_old = taxa_frete;
              this.taxa_entrega_v2 = taxa_frete;
              M.toast({
                html: 'Taxa de entrega atualizada: R$ ' + this.$store.state.empresa.taxa_entrega,
                displayLength: 5000
              });
            }
          }).catch(error => {
            console.log(error)
            this.isLoading = false;
            M.toast({html: "<strong class='red-text'>Endereço inválido</strong>", displayLength: 4000});
            this.taxa_entrega_calculo_mensagem_erro = true;
          });
        } else {
          this.isLoading = false;
        }
      }

      if (this.$store.state.empresa.forma_cobranca_frete == 'FIXO') {
        this.isLoading = false;
        this.taxa_entrega_calculo_mensagem_erro = false;
        // this.taxa_entrega_v2 = this.$store.state.empresa.taxa_entrega;
        // M.toast({
        //   html: 'Taxa de entrega aplicada: R$ ' + this.$store.state.empresa.taxa_entrega,
        //   displayLength: 5000
        // });
      }

      //this.ChegarProdutosSomenteParaRetirada();
      //this.isLoading = false;

      if ((this.$store.state.empresa.forma_cobranca_frete == 'BAIRRO') && (parametro == '')) {
        this.isLoading = false;
      }
      return;

    },
    LimparEndereco() {
      this.forma_entrega = "ENTREGA";
      this.endereco.bairro = "";
      this.endereco.cep = "";
      this.endereco.cidade_nome = "";
      this.endereco.complemento = "";
      this.endereco.numero = "";
      this.endereco.endereco = "";
      this.endereco.uf = this.$store.state.empresa.estado;
      this.nao_tem_cep = false;
      this.novo_endereco = false;
      this.bairro_id = "";

    },
    PedidoValido() {
      if (this.$store.state.pedido.itens.length <= 0 || this.pedido_enviado)
        return false;

      if (this.forma_entrega == "ENTREGA") {
        if (this.endereco_offiline_selecionado != null) {
          this.endereco_entrega_valido =
            this.endereco_offiline_selecionado.endereco != "" &&
            this.endereco_offiline_selecionado.bairro_nome != "" &&
            (this.endereco_offiline_selecionado.complemento != "" ||
              this.endereco_offiline_selecionado.numero) &&
            this.endereco_offiline_selecionado.cidade_nome != "" &&
            this.endereco_offiline_selecionado.uf != "";
        } else {
          this.endereco_entrega_valido =
            this.endereco.endereco != "" &&
            this.endereco.bairro != "" &&
            (this.endereco.complemento != "" || this.endereco.numero != "") &&
            this.endereco.uf != "" &&
            this.endereco.cidade_nome != "";
        }

        this.troco_valido =
          (this.precisa_troco &&
            this.troco_para_quanto > this.$store.getters.pedidoTotal) ||
          !this.precisa_troco;
      } else {
        this.endereco_entrega_valido = true;
        this.troco_valido =
          (this.precisa_troco &&
            this.troco_para_quanto > this.$store.getters.pedidoSubtotal) ||
          !this.precisa_troco;
      }

      $("#troco_valor").removeClass("invalid");
      if (!this.troco_valido && this.troco_para_quanto > 0)
        $("#troco_valor").addClass("invalid");

      $("#telefone").removeClass("invalid");
      if (this.telefone != "" && this.telefone.length < 14)
        $("#telefone").addClass("invalid");

      $("#cpf").removeClass("invalid");
      if (this.cpf_nota && !ValidarCPF(this.cpf)) $("#cpf").addClass("invalid");

      this.dados_pessoa_valido =
        this.nome_cliente != "" &&
        this.telefone.length >= 14 &&
        (!this.cpf_nota || ValidarCPF(this.cpf));

      return (
        this.endereco_entrega_valido &&
        this.troco_valido &&
        this.dados_pessoa_valido
      );
    },
    EnviarPedido() {
      if (!this.telefone) {
        Swal.fire({
          title: "Aviso",
          text: "Informe um telefone válido",
          icon: "info",
          customClass: {
            confirmButton: "confirm-button-class cor-primaria-bg",
          },
        });
        document.getElementById("telefone").focus();
        return false;
      }

      if (this.telefone.length < 14) {
        Swal.fire({
          title: "Aviso",
          text: "Informe um telefone válido",
          icon: "info",
          customClass: {
            confirmButton: "confirm-button-class cor-primaria-bg",
          },
        });
        document.getElementById("telefone").focus();
        return false;
      }

      if (this.cpf_nota) {
        if (!ValidarCPF(this.cpf)) {
          Swal.fire({
            title: "Aviso",
            text: "CPF Inválido!",
            icon: "error",
            customClass: {
              confirmButton: "confirm-button-class cor-primaria-bg",
            },
          });
          return false;
        }
      }

      if (this.forma_entrega == "ENTREGA") {
        if (this.endereco_offiline_selecionado != null) {
          this.endereco.cep = this.endereco_offiline_selecionado.cep;
          this.endereco.uf = this.endereco_offiline_selecionado.uf;
          this.endereco.cidade_nome = this.endereco_offiline_selecionado.cidade_nome;
          this.bairro_id = this.endereco_offiline_selecionado.bairro_id;
          this.endereco.bairro = this.endereco_offiline_selecionado.bairro_nome;
          this.endereco.endereco = this.endereco_offiline_selecionado.endereco;
          this.endereco.numero = this.endereco_offiline_selecionado.numero;
          this.endereco.complemento = this.endereco_offiline_selecionado.complemento;
        } else {
          this.SalvarEndereco();
        }
      }

      this.SalvarDados();

      var pedido = this.$store.state.pedido;
      pedido.nome_cliente = this.nome_cliente;
      pedido.cpf = this.cpf;
      pedido.telefone = this.telefone;
      if (
        this.forma_entrega == "ENTREGA" &&
        this.$store.state.empresa.forma_cobranca_frete == "BAIRRO"
      ) {
        pedido.taxa_entrega = this.$store.state.empresa.taxa_entrega;
      }

      if(this.conta_bancaria_id){
        pedido.conta_bancaria = this.conta_bancaria;
        pedido.conta_bancaria_id = this.conta_bancaria.codigo_interno;
      }

      pedido.forma_pagamento = this.forma_pagamento;
      pedido.forma_entrega = this.forma_entrega;
      pedido.precisa_troco = this.precisa_troco ? "S" : "N";
      pedido.troco_para_quanto = this.troco_para_quanto;
      pedido.entrega_cep = this.endereco.cep;
      pedido.entrega_bairro = this.endereco.bairro;
      pedido.entrega_endereco = this.endereco.endereco;
      pedido.entrega_cidade = this.endereco.cidade_nome;
      pedido.entrega_uf = this.endereco.uf;
      pedido.entrega_numero = this.endereco.numero;
      pedido.entrega_complemento = this.endereco.complemento;
      pedido.subtotal = this.$store.getters.pedidoSubtotal.toFixed(2);

      if(this.forma_pagamento === 'PAGHIPER_PIX'){
        pedido.chave_pre_pagamento = this.paghiper_pix.chave_rastreamento;
      }
      if(this.forma_pagamento === 'SOFTEXPRESS_CARTAO'){
        pedido.chave_pre_pagamento = this.softexpress_cartao.pagamento_chave_rastreamento;
      }

      pedido.valor_desconto = this.valor_desconto;
      pedido.valor_total = (this.forma_entrega == "ENTREGA"
          ? this.$store.getters.pedidoTotal - this.valor_desconto
          : this.$store.getters.pedidoSubtotal - this.valor_desconto
      ).toFixed(2);

      if(this.conta_bancaria){
        if(((this.conta_bancaria.ativo === "S") && (this.forma_pagamento === "TRANSFERENCIA"))) {
          pedido.conta_bancaria_id = this.conta_bancaria.codigo_interno;
        }
      }


      try{
        pedido.pedido_html = this.ObterHTMLdoPedido();
      }catch (e) {
        console.log(e);
      }

      // console.log(pedido.pedido_html);

      this.$store.commit("pedido", pedido);

      let isPrePagamento = this.paghiper_pix.pagamento_realizado || this.softexpress_cartao.pagamento_realizado;

      Swal.fire({
        title: "Aviso",
        text: !isPrePagamento ? " Deseja confirmar este pedido?" : "Seu pagamento foi recebido!",
        icon: "info",
        customClass: {
          confirmButton: "confirm-button-class cor-primaria-bg",
        },
        showCancelButton: !isPrePagamento,
        cancelButtonText: "Cancelar",
        confirmButtonText: !isPrePagamento ? " Sim" : "Enviar Pedido",
        showLoaderOnConfirm: true,
        allowOutsideClick: () => false,
        preConfirm: () => {
          return $.ajax({
            url:
              this.$store.state.apiUrl +
              "pedidos/novo/empresa/" +
              this.$store.state.empresa_url,
            data: this.$store.state.pedido,
            type: "POST",
            success: (data) => {
              Swal.hideLoading();
              this.pedido_enviado = true;

              console.log(data);
              this.numero_pedido = data.numero_pedido;
              this.codigo_rastreamento = data.codigo_rastreamento;

              if(this.forma_pagamento == 'MERCADOPAGOLINK'){
                this.link_pagamento_chave_rastreamento = data.uuid;
                this.link_pagamento = data.linkPagamento;
              }

              return true;
            },
            error: (data) => {
              var erro = "Erro ao enviar o seu pedido para o servidor";
              if (data.status < 500 && data.responseJSON && data.responseJSON.length > 0) {
                erro = data.responseJSON[0];
              }

              Swal.fire({
                title: "Aviso!",
                text: erro,
                icon: "error",
                customClass: {
                  confirmButton: "confirm-button-class materialize-red",
                },
              });

              return false;
            },
          });
        },
      }).then((result) => {

        if (this.$store.state.empresa.receber_pedidos_whatsapp == "S") {
          this.EnviarParaWhatsApp();
        }
      });
    },
    LimitarCaracteres(conteudo, tamanho) {
      var content = conteudo;
      var limit = parseInt(tamanho);
      if (content.length > limit) {
        return content.slice(0, limit) + "...";
      } else {
        return content + "";
      }
    },
    cpf_mask(v) {
      return v.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4");
    },
    RemoverItem(item) {
      Swal.fire({
        title: "Aviso",
        text: "Deseja realmente remover " + item.produto.nome,
        icon: "warning",
        customClass: {
          confirmButton: "confirm-button-class cor-primaria-bg",
        },
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((result) => {
        if (result.value) {
          this.$store.commit("remover_item_pedido", item);
          this.CalcularDesconto(null, this.forma_pagamento);
          this.valor_total = (
            parseFloat(this.$store.getters.getValorTotalPedido) +
            (this.forma_entrega == "ENTREGA"
              ? parseFloat(this.$store.state.empresa.taxa_entrega)
              : 0)
          ).toFixed(2);
          Swal.fire({
            title: "Removido!",
            text: "Item removido do pedido.",
            icon: "success",
            customClass: {
              confirmButton: "confirm-button-class cor-primaria-bg",
            },
          });
        }
      });
    },
    RemoverAdicional(item, adicionalRemover) {
      Swal.fire({
        title: "Aviso",
        text: "Deseja realmente remover " + adicionalRemover.nome,
        icon: "warning",
        customClass: {
          confirmButton: "confirm-button-class cor-primaria-bg",
        },
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((result) => {
        if (result.value) {
          this.$store.commit("remover_item_adicional_pedido", {
            item: item,
            adicional: adicionalRemover,
          });
          Swal.fire({
            title: "Removido!",
            text: "Item removido do pedido.",
            icon: "success",
            customClass: {
              confirmButton: "confirm-button-class cor-primaria-bg",
            },
          });
        }
      });
    },
    ObterValorFrete() {
      var valor = parseFloat(this.$store.state.empresa.taxa_entrega).toFixed(2);
      if (valor == "0.00") {
        return this.taxa_entrega_v2;
      } else {
        return "R$ " + valor;
      }
    },
    EnviarParaWhatsApp() {
      var pedidoStore = this.$store.state.pedido;
      pedidoStore.conta_bancaria = this.conta_bancaria
      let pedido = new WMCompose();

      var strNumPedido = this.numero_pedido.toString();
      var pad = "00000";
      strNumPedido =
        pad.substring(0, pad.length - strNumPedido.length) + strNumPedido;

      pedido.writeText(
        "*Pedido #" +
        strNumPedido +
        "* - _" +
        this.$store.state.empresa.nome +
        "_"
      );

      pedido.writeText("----------------------------------------", 1);

      pedidoStore.itens.forEach((item) => {
        pedido.writeText(
          "*" +
          item.quantidade +
          "x " +
          item.produto.nome +
          "* " +
          " R$ " +
          item.produto.valor,
          1
        );
        if (item.adicionais.length > 0) {
          item.adicionais.forEach((adicional) => {
            pedido.writeText(
              "   *" +
              (adicional.quantidade == undefined ? 1 : adicional.quantidade) *
              item.quantidade +
              "x " +
              adicional.nome +
              "* " +
              " R$ " +
              parseFloat(
                adicional.valor *
                (adicional.quantidade == undefined
                  ? 1
                  : adicional.quantidade) *
                item.quantidade
              ).toFixed(2),
              1
            );
          });
        }

        if (item.grades.grade) {
          pedido.writeText(
            "   *" + "Tamanho: " + item.grades.grade.tamanho + "* ",
            1
          );
        }
        //
        if (this.GetNomeCor(item.cores)) {
          pedido.writeText("   *" + "Cor: " + item.cores.cor.nome + "* ", 1);
        }

        if (item.observacao_cliente)
          pedido.writeText("*Obs:* _" + item.observacao_cliente + "_", 1);
      });
      pedido.writeText(
        "*Subtotal:* R$ " + this.$store.getters.pedidoSubtotal.toFixed(2),
        2,
        1
      );
      if (this.forma_entrega == "ENTREGA")
        pedido.writeText("*Taxa de entrega:* " + (this.ObterValorFrete() != "" ? this.ObterValorFrete() : " R$ 0.00") , 1, 1);

      if (this.valor_desconto > 0) {
        pedido.writeText(
          this.valor_desconto
            ? ("*Desconto:* R$ " + this.valor_desconto.toFixed(2))
            : "*Desconto:* R$ 0.00",
          1,
          1
        );
      }

      pedido.writeText(
        "*Total:* R$ " +
        (this.forma_entrega == "ENTREGA"
            ? this.$store.getters.pedidoTotal - this.valor_desconto
            : this.$store.getters.pedidoSubtotal - this.valor_desconto
        ).toFixed(2),
        1,
        1
      );

      pedido.writeText("---------------------------------", 1, 1);
      pedido.writeText("*Como deseja receber o pedido?*", 1);
      pedido.writeText("```" + pedidoStore.forma_entrega + "```", 1, 1);

      if (this.forma_entrega == "ENTREGA") {
        pedido.writeText("*Endereço de Entrega*", 1);
        pedido.writeText(
          pedidoStore.entrega_endereco +
          ", " +
          pedidoStore.entrega_numero +
          " - " +
          pedidoStore.entrega_complemento +
          " " +
          pedidoStore.entrega_bairro +
          ", " +
          pedidoStore.entrega_cidade +
          "/" +
          pedidoStore.entrega_uf,
          1
        );
        pedido.writeText(" " + pedidoStore.entrega_cep, 1, 1);
      }

      pedido.writeText("*Forma de Pagamento*", 1, 1);
      pedido.writeText("```" + this.FormatarFormaPagamento(pedidoStore.forma_pagamento) + "```", 0, 1);

      if(pedidoStore.forma_pagamento == "MERCADOPAGOLINK") {
        pedido.writeText("*Link de Pagamento*", 2);
        pedido.writeText(this.link_pagamento, 1);

        pedido.writeText("*Visualizar Status do Pagamento*", 2);
        pedido.writeText(this.$store.state.empresa.sirrus_delivery_link + "pagamentos/mercadopago/rastrear/" + this.link_pagamento_chave_rastreamento, 1);
      }

      if (pedidoStore.forma_pagamento == "PIX") {
        // pedido.writeText("*Chave*", 2);
        let forma_pagamento_texto_amigavel = '';
        switch (this.$store.state.empresa.pagamento_pix_chave_tipo) {
          case("CHAVE_ALEATORIA"):
            forma_pagamento_texto_amigavel = "*Chave Aleatória*";
            break;
          case("CELULAR"):
            forma_pagamento_texto_amigavel = "*Celular*";
            break;
          case("CPF_CNPJ"):
            forma_pagamento_texto_amigavel = "*CPF/CNPJ*";
            break;
          case("EMAIL"):
            forma_pagamento_texto_amigavel = "*E-mail*";
            break;
        }

        // pedido.writeText("```" + forma_pagamento_texto_amigavel + "```"+": "+this.$store.state.empresa.pagamento_pix_chave , 1);
        pedido.writeText("*Chave*" + " "+forma_pagamento_texto_amigavel +": *"+this.$store.state.empresa.pagamento_pix_chave+"*" , 1);
        pedido.writeText("*Beneficiário*: "+this.$store.state.empresa.pagamento_pix_nome_conta, 1);

        // pedido.writeText("*PIX - Chave Pagamento:*", 1);
        // pedido.writeText("```" + this.$store.state.empresa.pagamento_pix_chave + "```", 1);
      }

      if (pedidoStore.precisa_troco == "S") {
        pedido.writeText("*Precisa de troco?*", 1);
        pedido.writeText("Sim, para R$" + pedidoStore.troco_para_quanto, 1, 1);
      }

      if(pedidoStore.conta_bancaria){
          if(((pedidoStore.conta_bancaria.ativo === "S") && (pedidoStore.forma_pagamento === "TRANSFERENCIA"))) {
            pedido.writeText("*Conta Selecionada*", 2);
            pedido.writeText("Banco: " + pedidoStore.conta_bancaria.banco.nome + " ("+ pedidoStore.conta_bancaria.banco.codigo +")", 1);
            pedido.writeText("Agência: " + pedidoStore.conta_bancaria.agencia, 1);
            pedido.writeText("Conta: " + pedidoStore.conta_bancaria.conta, 1);
            pedido.writeText("Tipo Conta: " + pedidoStore.conta_bancaria.tipo_conta, 1);
            pedido.writeText("Titular: " + pedidoStore.conta_bancaria.nome, 1);
            pedido.writeText("CPF/CNPJ: " + pedidoStore.conta_bancaria.cpf_cnpj, 1);
            if(pedidoStore.conta_bancaria.informacoes_adicionais) {
              pedido.writeText("Observações: " + pedidoStore.conta_bancaria.informacoes_adicionais, 1);
            }
          }
      }

      pedido.writeText("*Cliente:* " + pedidoStore.nome_cliente, 2);
      pedido.writeText("*Telefone:* " + pedidoStore.telefone, 1);
      if (this.cpf_nota)
        pedido.writeText("*CPF:* " + this.cpf_mask(pedidoStore.cpf), 1);

      var horaAtual = new Date();
      var strHoraAtual =
        ("0" + horaAtual.getHours()).slice(-2) +
        ":" +
        ("0" + horaAtual.getMinutes()).slice(-2);

      pedido.writeText(
        "*Recibo Digital:* " +
        this.$store.state.app_url +
        this.$store.state.empresa.usuario_url +
        "/recibo-digital/" +
        this.codigo_rastreamento,
        2
      );

      pedido.writeText(
        "_Pedido gerado por Sirrus Sistemas" + " às  " + strHoraAtual + "_",
        2
      );

      WMSend(this.$store.state.empresa.whatsapp, pedido.getText());

      setTimeout(() => {
        location.reload();
      }, 700);
    },
    maxLengthCheck() {
      if (this.endereco.cep.length > 8)
        this.endereco.cep = this.endereco.cep.slice(0, 8);
    },
    PesquisarCep() {
      console.log(this.$store.state.empresa.forma_cobranca_frete);
      if (!ValidarCEP(this.endereco.cep))
        return;

      this.isLoading = true;
      ObterEnderecoPorCep(this.endereco.cep).then(response => {
        // Verifica se a resposta indica que o CEP não foi encontrado
        if (response.erro) {
          // Mostra uma mensagem de erro ou toma alguma ação correspondente
          this.mostrarMensagemCEPInvalido();
          this.isLoading = false;
          return;
        }

        // Caso contrário, o CEP foi encontrado
        this.endereco = response;
        this.bairro_id = ObterBairroIdPorBairroNome(this.$store.state.empresa.tarifas_entrega_bairro, response.bairro);

        if (this.bairro_id != 0) {
          if (this.$store.state.empresa.forma_cobranca_frete != 'TABELA_KM') {
            this.CalcularFrete(this.bairro_id)
          }
        } else {
          if (this.$store.state.empresa.forma_cobranca_frete == 'BAIRRO') {
            this.isLoading = false;
            this.desativarEntrega('Região indisponível', true);
          }
        }

        this.isLoading = false;
      });
    },
    // pesquisacep(valor) {
    //   var cep = this.endereco.cep;
    //   this.isLoading = true;
    //   if (cep != "") {
    //     var validacep = /^[0-9]{8}$/;
    //     if (validacep.test(cep)) {
    //       this.CalcularFrete("cep=" + cep);
    //       $.getJSON(
    //         "https://viacep.com.br/ws/" + cep + "/json/?callback=?",
    //         (dados) => {
    //           if (!("erro" in dados)) {
    //             this.endereco.endereco = dados.logradouro;
    //             this.endereco.bairro = dados.bairro;
    //             this.endereco.uf = dados.uf;
    //             this.endereco.cidade_nome = dados.localidade;
    //             this.isLoading = false;
    //           } else {
    //             this.isLoading = false;
    //             Swal.fire({
    //               title: "Aviso",
    //               text: "CEP não encontrado.",
    //               icon: "info",
    //               customClass: {
    //                 confirmButton: "confirm-button-class cor-primaria-bg",
    //               },
    //             });
    //           }
    //         }
    //       );
    //     } else {
    //       this.isLoading = false;
    //       Swal.fire({
    //         title: "Aviso",
    //         text: "Formato de CEP inválido.",
    //         icon: "info",
    //         customClass: {
    //           confirmButton: "confirm-button-class cor-primaria-bg",
    //         },
    //       });
    //     }
    //   } else {
    //     this.isLoading = false;
    //   }
    // },
    cep_mask(v) {
      return v.replace(/(\d{5})/g, "\$1-");
    },
    ObterHTMLdoPedido() {
      var pedidoStore = this.$store.state.pedido;
      let pedido = new WMCompose();

      pedido.writeText("------------------------------------<br>", 1);
      pedidoStore.itens.forEach(item => {
        pedido.writeText("<strong>" + item.quantidade + 'x ' + item.produto.nome + "</strong> - R$ " + (item.quantidade * parseFloat(item.produto.valor)).toFixed(2) + "<br>", 1);

        if(this.$store.state.empresa.mostrar_categoria_wpp == "S"){
          item.categorias.forEach(categoria => {
            pedido.writeText("  <strong>" + categoria.descricao + "</strong><br>", 1);
            categoria.adicionais.forEach(adicional => {
              pedido.writeText("    " + ((adicional.quantidade || 1) * item.quantidade) + 'x ' + adicional.nome + " - R$ " + (parseFloat(adicional.valor * (adicional.quantidade || 1)  * item.quantidade).toFixed(2)) + "<br>", 1);
            });
          });
        }
        else {
          item.adicionais.forEach(adicional => {
            pedido.writeText("    " + ((adicional.quantidade || 1) * item.quantidade) + 'x ' + adicional.nome + " - R$ " + (parseFloat(adicional.valor * (adicional.quantidade || 1)  * item.quantidade).toFixed(2)) + "<br>", 1);
          });
        }

        if (item.grades.grade) {
          pedido.writeText(
            "   <strong>" + "Tamanho: " + item.grades.grade.tamanho + "</strong> <br>",
            1
          );
        }
        //
        if (this.GetNomeCor(item.cores)) {
          pedido.writeText("   <strong>" + "Cor: " + item.cores.cor.nome + "</strong> <br>", 1);
        }


        if(item.observacao_cliente)
          pedido.writeText("<strong>Obs:</strong> <i>" + item.observacao_cliente + "</i><br>", 1);
      });

      pedido.writeText("------------------------------------<br>", 1);

      pedido.writeText("<strong>Subtotal:</strong> R$ " + this.$store.getters.pedidoSubtotal.toFixed(2) + "<br>", 1, 1);

      if (this.forma_entrega == "ENTREGA")
        pedido.writeText("<br><strong>Taxa de entrega:</strong> " + this.ObterValorFrete() + "<br>", 1, 1)

      pedido.writeText("<strong>Total:</strong> R$ " + (this.forma_entrega == 'ENTREGA' ? this.$store.getters.pedidoTotal : this.$store.getters.pedidoSubtotal).toFixed(2) + "<br>", 1)
      pedido.writeText("------------------------------------<br>", 1);
      pedido.writeText("<strong>Como deseja receber o pedido?</strong><br>", 1);
      pedido.writeText("<span>" + pedidoStore.forma_entrega + "</span><br>", 1);

      if (this.forma_entrega == 'ENTREGA') {
        pedido.writeText("<strong>Endereço de Entrega</strong><br>", 2);
        pedido.writeText(pedidoStore.entrega_endereco + ", " + (pedidoStore.entrega_numero || "S/N") + (pedidoStore.entrega_complemento ? " - " + pedidoStore.entrega_complemento : "") + "<br>", 1);
        pedido.writeText(pedidoStore.entrega_bairro + ", " + pedidoStore.entrega_cidade + "/" + pedidoStore.entrega_uf + "<br>", 1);
        if (pedidoStore.entrega_cep)
          pedido.writeText(this.cep_mask(pedidoStore.entrega_cep) + "<br>", 1);
      }

      pedido.writeText("<br><strong>Forma de Pagamento</strong><br>", 2);
      pedido.writeText("<span>" + this.FormatarFormaPagamento(pedidoStore.forma_pagamento) + "</span><br>", 1);

      if (pedidoStore.forma_pagamento == "MERCADOPAGOLINK") {
        pedido.writeText("<strong>Link de Pagamento</strong><br>", 2);
        pedido.writeText(this.link_pagamento + "<br>", 1);

        pedido.writeText("<strong>Visualizar Status do Pagamento</strong><br>", 2);
        pedido.writeText(this.$store.state.empresa.sirrus_delivery_link + "pagamentos/mercadopago/rastrear/" + this.link_pagamento_chave_rastreamento + "<br>", 1);
      }

      if (pedidoStore.forma_pagamento == "PIX") {
        pedido.writeText("<br><strong>PIX - Tipo:</strong><br>", 2);
        let forma_pagamento_texto_amigavel = '';
        switch (this.$store.state.empresa.pagamento_pix_chave_tipo) {
          case("CHAVE_ALEATORIA"):
            forma_pagamento_texto_amigavel = "Chave Aleatória";
            break;
          case("CELULAR"):
            forma_pagamento_texto_amigavel = "Celular";
            break;
          case("CPF_CNPJ"):
            forma_pagamento_texto_amigavel = "CPF/CNPJ";
            break;
          case("EMAIL"):
            forma_pagamento_texto_amigavel = "E-mail";
            break;
        }

        pedido.writeText("<span>" + forma_pagamento_texto_amigavel + "</span><br>", 1);

        pedido.writeText("<strong>PIX - Chave Pagamento:</strong><br>", 1);
        pedido.writeText("<span>" + this.$store.state.empresa.pagamento_pix_chave + "</span><br>", 1);
      }

      if (pedidoStore.precisa_troco == "S") {
        pedido.writeText("<strong>Precisa de troco?</strong><br><br>", 2);
        pedido.writeText("Sim, para R$" + pedidoStore.troco_para_quanto + "<br>", 1);
      }

      if (pedidoStore.conta_bancaria) {
        if (((pedidoStore.conta_bancaria.ativo === "S") && (pedidoStore.forma_pagamento === "TRANSFERENCIA"))) {
          pedido.writeText("<strong>Conta Selecionada</strong><br>", 2);
          pedido.writeText("Banco: " + pedidoStore.conta_bancaria.banco.nome + " (" + pedidoStore.conta_bancaria.banco.codigo + ")" + "<br>", 1);
          pedido.writeText("Agência: " + pedidoStore.conta_bancaria.agencia + "<br>", 1);
          pedido.writeText("Conta: " + pedidoStore.conta_bancaria.conta + "<br>", 1);
          pedido.writeText("Tipo Conta: " + pedidoStore.conta_bancaria.tipo_conta + "<br>", 1);
          pedido.writeText("Titular: " + pedidoStore.conta_bancaria.nome + "<br>", 1);
          pedido.writeText("CPF/CNPJ: " + pedidoStore.conta_bancaria.cpf_cnpj + "<br>", 1);
          if (pedidoStore.conta_bancaria.informacoes_adicionais) {
            pedido.writeText("Observações: " + pedidoStore.conta_bancaria.informacoes_adicionais + "<br>", 1);
          }
        }
      }


      pedido.writeText("<strong>Cliente:</strong> " + pedidoStore.nome_cliente + "<br><br>", 2);
      pedido.writeText("<strong>Telefone:</strong> " + pedidoStore.telefone + "<br>", 1);
      if (this.cpf_nota)
        pedido.writeText("<strong>CPF:</strong> " + this.cpf_mask(pedidoStore.cpf) + "<br>", 1);

      return pedido.getText();
    },
  },
};
</script>


<style scoped>
.btn {
  height: 20px;
  line-height: 13px;
  font-size: 11px;
}
td,
th {
  padding: 3px 5px;
  display: table-cell;
  text-align: left;
  vertical-align: middle;
  border-radius: 2px;
}
.bloco {
  margin: 10px auto;
}
.content-e {
  text-align: center;
}
.inner-e {
  display: inline-block;
}
.valid-badge {
  position: absolute;
  top: 10px;
  right: 12px;
}
.valid-check {
  position: absolute;
  top: 2px;
  right: 12px;
}
</style>



// WEBPACK FOOTER //
// src/app/views/OrderView.vue